<template>
  <div>
    <h5>Select file type</h5>
    <b-form-select
        v-model="fileType"
        :options="metaList"
        
        value-field="item"
        text-field="name"
        disabled-field="notEnabled"
        style="max-width: 300px;"
        size="lg"
        ></b-form-select>

    <div class="mt-4 text-right">
      <b-button
        v-if="supportNext"
        variant="primary"
        class="px-5"
        @click="onSuccess">
        Next
      </b-button>

      <b-button
        v-else
        variant="primary"
        class="px-5"
        @click="saveChanges"
        :disabled="isSaving">
        <i class="fa fa-spin fa-spinner mr-2" v-if="isSaving"/>
        <span>Save&nbsp;</span>
        <span v-if="supportNext">& Continue</span>
        <span v-else>Changes</span>
      </b-button>
    </div>
  </div>
</template>

<script>
  import {updateFileType} from '../../store/files';

  export default {
    name: 'FileTypeMap',
    props: {
      meta: Object,
      supportNext: Boolean,
      file: String
    },
    data() {
      const {entities, type} = this.meta;
      let fileType = null;

      return {
        // rawFile,
        fileType,
        isSaving: false
      };
    },

    watch: {
    },

    computed: {
      orderedMetas() {
        return this.meta.entities;
      },

      orderedColumns() {
        let metaOptions = [];
        this.$store.state.general.metas.forEach(meta => {
          metaOptions.push(meta.type);
        });
        return metaOptions;
      },
      
      // orderedColumns() {
      //   return this.file.columns.sort((a, b) => {
      //     const nameA = a.name.toUpperCase(); // ignore upper and lowercase
      //     const nameB = b.name.toUpperCase(); // ignore upper and lowercase
      //     if (nameA < nameB) return -1;
      //     if (nameA > nameB) return 1;
      //     return 0;
      //   });
      // }
      
      metaList() {
        // console.log('File: ', this.rawFile);
        var metaList = [];
        this.$store.state.general.metas.forEach(meta => {
          metaList.push(meta.type);
        });
        return metaList;
      }
    },

    methods: {
      onSuccess() {
        this.$emit('success');
      },

      saveChanges() {
        let rawFile = null;
        let fileID = null;
        this.$store.state.files.fileList.forEach(f => {
            if (f.originalName === this.file) {
              fileID = f.id;
            }
          });
        console.log('File: ', this.file);
        console.log('FileType: ', this.fileType);
        // const {id: fileID} = rawFile;

        this.isSaving = true;
        this.$store.dispatch(updateFileType(fileID, this.fileType))
          .then(() => {
            this.onSuccess();
          })
          .catch(console.log)
          .finally(() => {this.isSaving = false;});
      },
    }

  };
</script>

<style scoped>

</style>
